import { useMailInput } from "./useEmailInput";
import { Controller } from "react-hook-form";
import InputUI from "../../../../../../UI/InputUI/InputUI";
import { useEmailInputStyle } from "./style";
import React from "react";

const TextArea = () => {
  const { control, emailReg } = useMailInput();
  return (
    <Controller
      name="email"
      control={control}
      defaultValue={""}
      rules={{ required: true, pattern: emailReg }}
      render={({ field: { value, onChange }, fieldState: { error } }) => {
        return (
          <InputUI
            value={value}
            onChange={onChange}
            error={!!error}
            styleComponents={{ InputStyle: InputEmail }}
            inputProps={{
              type: "email",
              inputMode: "email",
              placeholder: "E-mail / Телефон",
            }}
          />
        );
      }}
    />
  );
};

const { InputEmail } = useEmailInputStyle();

export default React.memo(TextArea);
